export default __webpack_public_path__ + "static/headerImageMobile-d91471e015cf482b1d7554acdce9e53e.webp";